"use client";
import { jsxs as l, jsx as r } from "react/jsx-runtime";
import g from "classnames";
import { Avatar as L } from "@zapier/design-system";
import { s as o } from "../../Author.module-DO0Qr1K7.mjs";
import { SocialLinks as j } from "./SocialLinks/SocialLinks.es.js";
import { AuthorLabel as A } from "./AuthorLabel.es.js";
import { AuthorMeta as I } from "./AuthorMeta.es.js";
const e = (a) => {
  if (!a || typeof a != "string" || a.trim() === "")
    return;
  const t = a.trim();
  try {
    const s = t.startsWith("http://") || t.startsWith("https://") ? t : `https://${t}`, i = new URL(s);
    return i.protocol !== "https:" && i.protocol !== "http:" ? void 0 : i.toString();
  } catch {
    return;
  }
}, _ = ({ author: a, label: t, className: s, style: i, testId: h }) => {
  var n;
  const { name: m, jobTitle: u, company: v, avatarImage: d, url: p, linkedInUrl: f, twitterUrl: N, facebookUrl: U, instagramUrl: k, isCompanyProfile: b = !1 } = a, c = {
    linkedin: e(f),
    twitter: e(N),
    facebook: e(U),
    instagram: e(k)
  }, y = e(p);
  return /* @__PURE__ */ l("div", { className: o.authorWithLabel, children: [
    /* @__PURE__ */ r(A, { label: t ?? "Created by" }),
    /* @__PURE__ */ l("div", { className: g(o.authorCard, s), style: i, "data-testid": h, children: [
      /* @__PURE__ */ r("div", { className: o.avatar, "data-testid": "author-avatar", children: /* @__PURE__ */ r(L, { name: m || "?", url: (n = d?.url) !== null && n !== void 0 ? n : null, size: "medium" }) }),
      /* @__PURE__ */ l("div", { className: o.authorInfo, children: [
        /* @__PURE__ */ l("div", { className: o.authorNameMeta, children: [
          /* @__PURE__ */ r("div", { className: o.authorName, children: m }),
          /* @__PURE__ */ r(I, { title: u, company: v, url: y, isCompanyProfile: b })
        ] }),
        Object.values(c).some(Boolean) && /* @__PURE__ */ r(j, { socialLinks: c, authorName: m, testId: "social-links" })
      ] })
    ] })
  ] });
};
export {
  _ as Author
};
//# sourceMappingURL=Author.es.js.map
